import React from "react";
import type Highcharts from "highcharts";
import useChartEventHandler from "./useChartEventHandler";

const useTooltipClick = <TooltipAction extends string>(
  chartRef: React.RefObject<Highcharts.Chart>,
  onClick: (action: TooltipAction, points: Highcharts.Point[]) => void,
) => {
  const handleTooltipClick = React.useCallback(
    (e: Highcharts.TooltipClickEventObject) => {
      const chart = chartRef.current;
      if (!chart) {
        throw new Error("no chart yet?");
      }
      const action = e.action as TooltipAction;
      onClick(action, e.points);
      chart.tooltip.destroy(); // update tooltip content
    },
    [chartRef, onClick],
  );
  useChartEventHandler(
    chartRef,
    "tooltipClick",
    handleTooltipClick as Highcharts.EventCallbackFunction<Highcharts.Chart>,
  );
};

export default useTooltipClick;
